module.exports = __webpack_public_path__ + "img/kenneth-pro.cbe4fd72.jpg";